/*
 * File: cell-action-edit.ts
 * Created: 2025-12-06 10:17:13
 * Author: Val Liu <valuis0429@gmail.com>
 * -----
 * Last Modified: 2025-12-09 16:02:28
 * Modified By: Val Liu <valuis0429@gmail.com>
 */

import { Component, Prop } from "vue-property-decorator";
import CellActionBase from "../../base/cell-action-base";

@Component
export default class CellActionDelete extends CellActionBase {
    get defaultLabel(): string {
        return this.label ?? `{w_QuickList_DeleteItem("${this.quick.title}")}`;
    }
}
